import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../redux';
import * as React from 'react';
import {useEffect} from 'react';
import {Route, useNavigation, StackActions} from '@react-navigation/native';
import {pollDetailsSelector} from '../../redux/selectors/polls';
import {PollType} from '../models/poll';
import {Screens} from '../routing';
import {setPollDetails} from '../../redux/actions/polls/details';

type ResolverProps = {route: Route<string>} & any;

const pollScreensByType: Record<PollType, Screens[]> = {
  [PollType.Voting]: [Screens.PollsTypeVoteForm],
  [PollType.Survey]: [Screens.PollsTypeSurveyForm],
};

const pollScreensLinking: Record<any, Screens> = {
  [Screens.PollsTypeVoteForm]: Screens.PollsTypeSurveyForm,
  [Screens.PollsTypeSurveyForm]: Screens.PollsTypeVoteForm,
};

export const PollDetailsTypeResolver = (viewComponent: React.FC<any>) => {
  return function Resolver(props: ResolverProps) {
    const poll = useSelector(pollDetailsSelector());
    const type = poll?.type || null;
    const nav = useNavigation();
    const dispatch = useAppDispatch();

    useEffect(() => {
      if (!pollScreensByType[type as PollType]) {
        return;
      }

      if (!pollScreensByType[type as PollType].includes(props.route.name)) {
        if (pollScreensLinking[props.route.name]) {
          dispatch(setPollDetails(null));
          nav.dispatch(StackActions.replace(pollScreensLinking[props.route.name], props.route.params));
        }
      }
    }, [poll]);

    if (poll) {
      if (!pollScreensByType[poll.type as PollType].includes(props.route.name)) {
        return null;
      }
    }

    return React.createElement(viewComponent, props);
  };
};
